/**
 * GA4 + Google Ads 双埋点追踪 - v2.0 (Jacquardwork)
 * ============================================================
 * 升级内容（vs v1）：
 *   ✅ 保留 v1 全部功能（GA4 page_view / CTA / WhatsApp / Email / WeChat）
 *   🆕 [Patch A] GCLID / GBRAID / WBRAID 捕获 & cookie 持久化（90 天）
 *   🆕 [Patch B] WhatsApp 链接动态注入追踪标识（GCLID + UTM + Page）
 *   🆕 [Patch C] CTA 点击同步触发 Google Ads conversion（关键）
 *   🆕 [Patch D] 用户标识符（email/phone）哈希采集（用于 Enhanced Conversions）
 *   🆕 [Patch E] 字段卫生：UTM session 持久化、WhatsApp link_url 短链、
 *      theme preview / localhost 不打 gtag（写入 window.__jwPreviewEvents）
 *
 * 部署前必读：
 *   1. <head> 必须同时加载 GA4 + Ads gtag（见底部部署说明）
 *   2. 在 Google Ads 后台建好 3 个转化操作后，把转化标签填入下方 ADS_CONFIG
 *   3. position 已统一：sidebar → floating_sidebar（与你 GA4 数据一致）
 *
 * 修复历史（继承 v1）：
 *   1. getClusterName() 改为从 URL 路径自动推断
 *   2. 所有 .js-cta 缺失 data-cta-channel 时 fallback 为 'other'
 *   3. 新增 WeChat 链接识别（weixin:// 协议 & 常见微信域名）
 *   4. gtag script 建议移至 <head>
 * ============================================================
 */

/* ============================================================
 * 全局配置 - 部署前修改
 * ============================================================ */
window.ADS_CONFIG = window.ADS_CONFIG || {
  // Google Ads Customer ID（不带横线，仅用于日志）
  customer_id: '6403386843',

  // Google Ads Conversion ID（在 Ads 后台「工具→转化」每个转化都会有一个 AW-XXXXXXXXX）
  // 所有 jacquardwork 转化都在同一个账号下，所以共用一个 conversion_id
  // 部署前：在 Google Ads 后台建好账号级 gtag 后填入
  conversion_id: 'AW-XXXXXXXXX',

  // 各渠道的转化标签（每个转化操作有独立的 conversion_label）
  // 部署前：在 Google Ads 后台建好转化后填入
  conversions: {
    whatsapp: { label: 'AAAAAAAAAAAA',  value: 50, currency: 'USD' },
    email:    { label: 'BBBBBBBBBBBB',  value: 30, currency: 'USD' },
    wechat:   { label: 'CCCCCCCCCCCC',  value: 20, currency: 'USD' },
    form:     { label: 'DDDDDDDDDDDD',  value: 80, currency: 'USD' }  // 表单提交（最高价值）
  }
};

(function () {
  'use strict';

  var GA4_GTAG_MAX_WAIT_MS = 5000;
  var GA4_GTAG_POLL_MS = 80;

  function isLocalPreviewHost(hostname) {
    var host = (hostname || '').toLowerCase();
    return host === 'localhost' ||
      host === '0.0.0.0' ||
      host === '::1' ||
      host === '[::1]' ||
      /^127(?:\.\d{1,3}){3}$/.test(host) ||
      /^10(?:\.\d{1,3}){3}$/.test(host) ||
      /^192\.168(?:\.\d{1,3}){2}$/.test(host) ||
      /^172\.(1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2}$/.test(host);
  }

  function isThemePreview() {
    try {
      return Boolean(window.ga_preview_mode) ||
        /(?:[?&](?:preview_theme_id|preview_key)=)/i.test(window.location.href);
    } catch (e) {
      return false;
    }
  }

  var previewMode = isLocalPreviewHost(window.location.hostname) || isThemePreview();
  window.B2B_GA4_PREVIEW_MODE = previewMode;
  if (previewMode) {
    window.B2B_GA4_TRACKING_DISABLED = true;
    if (typeof console !== 'undefined' && console.info) {
      console.info('GA4: preview mode, events stay in window.__jwPreviewEvents');
    }
  }

  function waitForGtag(callback) {
    if (previewMode) {
      callback();
      return;
    }
    var elapsed = 0;
    function check() {
      if (typeof window.gtag === 'function') {
        callback();
        return;
      }
      elapsed += GA4_GTAG_POLL_MS;
      if (elapsed >= GA4_GTAG_MAX_WAIT_MS) {
        if (typeof console !== 'undefined' && console.warn) {
          console.warn('GA4: gtag 未在 ' + (GA4_GTAG_MAX_WAIT_MS / 1000) + 's 内就绪，跳过初始化');
        }
        return;
      }
      setTimeout(check, GA4_GTAG_POLL_MS);
    }
    check();
  }

  /* ============================================================
   * [Patch A] GCLID 捕获 & cookie 持久化（在 waitForGtag 之前执行）
   * ============================================================ */
  function getCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]+)'));
    return m ? decodeURIComponent(m[1]) : '';
  }

  function setCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 86400000);
    document.cookie = name + '=' + encodeURIComponent(value) +
      '; expires=' + d.toUTCString() + '; path=/; SameSite=Lax';
  }

  try {
    var urlParams = new URLSearchParams(window.location.search);
    var gclid  = urlParams.get('gclid');
    var gbraid = urlParams.get('gbraid');
    var wbraid = urlParams.get('wbraid');

    if (gclid)  setCookie('_gcl_aw_custom',  gclid,  90);
    if (gbraid) setCookie('_gbraid_custom',  gbraid, 90);
    if (wbraid) setCookie('_wbraid_custom',  wbraid, 90);

    window.getStoredGclid = function () {
      return getCookie('_gcl_aw_custom') || getCookie('_gcl_aw') || '';
    };
    window.getStoredGbraid = function () { return getCookie('_gbraid_custom'); };
    window.getStoredWbraid = function () { return getCookie('_wbraid_custom'); };
  } catch (e) {
    console.warn('[Patch A] GCLID capture failed:', e);
  }

  waitForGtag(function () {
    var id = window.ga_measurement_id || 'G-5EVDVD1GWK';

    function s(v) { return (v === undefined || v === null) ? '' : String(v).trim(); }

    function inferPageType(pathname) {
      try {
        var p = (pathname || location.pathname || '/').toLowerCase();
        if (p === '/' || p === '') return 'home';
        if (p.indexOf('/collections/') === 0) return 'collections';
        if (p.indexOf('/pages/contact') === 0 || p.indexOf('/contact') === 0) return 'contact';
        if (p.indexOf('/pages/') === 0) return 'landing_page';
        if (p.indexOf('/blogs/') === 0) return 'blog';
        if (p.indexOf('/products/') === 0) return 'product';
        if (p.indexOf('/search') === 0) return 'search';
        return 'other';
      } catch (e) { return 'other'; }
    }

    /**
     * [修复 1] getClusterName：从 URL 路径推断关键词簇
     */
    function getClusterName() {
      try {
        var el = document.querySelector('[data-cluster]');
        if (el) {
          var v = el.getAttribute('data-cluster');
          if (v) return String(v).trim();
        }
        var meta = document.querySelector('meta[name="cluster"]');
        if (meta && meta.content) return String(meta.content).trim();

        var p = location.pathname.toLowerCase();

        if (p.indexOf('/collections/low-moq-custom-jacquard-fabric') >= 0) return 'low_moq_custom_jacquard';
        if (p.indexOf('/collections/jacquard-fabric-for-bags') >= 0 || p.indexOf('/pages/jacquard-fabric-for-bags') >= 0) return 'bags_accessories_jacquard';
        if (p.indexOf('/collections/jacquard-curtain-fabric') >= 0 || p.indexOf('/pages/jacquard-curtain-fabric') >= 0) return 'curtain_drapery_jacquard';
        if (p.indexOf('/collections/jacquard-sofa-fabric') >= 0 || p.indexOf('/pages/jacquard-sofa-fabric') >= 0 || p.indexOf('/pages/furniture-manufacturer-supply') >= 0 || p.indexOf('/pages/jacquard-upholstery-fabric') >= 0) return 'sofa_upholstery_jacquard';
        if (p.indexOf('/collections/jacquard-apparel-fabric') >= 0 || p.indexOf('/pages/apparel-jacquard-fabric') >= 0) return 'apparel_jacquard';
        if (p.indexOf('/collections/soft-hidden-samples') >= 0) return 'internal_samples';

        if (p.indexOf('/pages/custom-jacquard-development') >= 0 || p.indexOf('/pages/custom-jacquard-fabric') >= 0) return 'custom_jacquard_oem';
        if (p.indexOf('/pages/water-jet-jacquard-fabric') >= 0) return 'water_jet_jacquard';
        if (p.indexOf('/pages/chenille-jacquard-fabric') >= 0 || p.indexOf('/pages/chenille-jacquard') >= 0) return 'chenille_jacquard';
        if (p.indexOf('/pages/poly-cotton-jacquard') >= 0 || p.indexOf('/pages/cotton-poly-jacquard-fabric') >= 0) return 'poly_cotton_jacquard';
        if (p.indexOf('/pages/fine-thread-jacquard') >= 0 || p.indexOf('/pages/lightweight-jacquard-fabric') >= 0) return 'lightweight_jacquard';
        if (p.indexOf('/pages/specialty-yarn-jacquard') >= 0) return 'specialty_yarn_jacquard';
        if (p.indexOf('/pages/multi-color-warp-jacquard') >= 0 || p.indexOf('/pages/color-rich-jacquard-fabric') >= 0) return 'color_rich_jacquard';
        if (p.indexOf('/pages/mono-warp-jacquard') >= 0) return 'mono_warp_jacquard';
        if (p.indexOf('/pages/floral-jacquard-fabric') >= 0) return 'floral_jacquard';
        if (p.indexOf('/pages/yarn-dyed-jacquard-fabric') >= 0) return 'yarn_dyed_jacquard';
        if (p.indexOf('/pages/hospitality-furniture-fabric') >= 0) return 'hospitality_jacquard';
        if (p.indexOf('/pages/jacquard-fabric-for-home-textile-products') >= 0 || p.indexOf('/pages/decorative-interior-jacquard-fabric') >= 0 || p.indexOf('/pages/jacquard-tapestry') >= 0) return 'home_textile_jacquard';

        return '';
      } catch (e) { return ''; }
    }

    function readUtmFromUrl() {
      try {
        var params = new URLSearchParams(window.location.search);
        return {
          utm_source: params.get('utm_source') || '',
          utm_medium: params.get('utm_medium') || '',
          utm_campaign: params.get('utm_campaign') || '',
          utm_content: params.get('utm_content') || '',
          utm_term: params.get('utm_term') || ''
        };
      } catch (e) {
        return { utm_source: '', utm_medium: '', utm_campaign: '', utm_content: '', utm_term: '' };
      }
    }

    function getUTMParams() {
      if (window.ga_utm && window.ga_utm.utm_source) return window.ga_utm;
      var current = readUtmFromUrl();
      try {
        if (current.utm_source && window.sessionStorage) {
          sessionStorage.setItem('jw_ga4_utm', JSON.stringify(current));
        } else if (window.sessionStorage) {
          var stored = sessionStorage.getItem('jw_ga4_utm');
          if (stored) {
            var parsed = JSON.parse(stored);
            if (parsed && parsed.utm_source) current = parsed;
          }
        }
      } catch (e) {}
      window.ga_utm = current;
      return current;
    }

    function normalizeWhatsAppLinkUrl(href) {
      var original = s(href);
      try {
        var url = new URL(original, window.location.origin);
        var protocol = url.protocol.toLowerCase();
        var host = url.hostname.toLowerCase().replace(/^www\./, '');
        var phone = s(url.searchParams.get('phone')).replace(/\D/g, '');

        if (protocol === 'whatsapp:') return phone ? 'https://wa.me/' + phone : 'whatsapp://send';
        if (host === 'wa.me') return 'https://wa.me' + url.pathname.replace(/\/+$/, '');
        if (host === 'api.whatsapp.com' || host === 'whatsapp.com') {
          return phone ? 'https://wa.me/' + phone : url.origin + url.pathname.replace(/\/+$/, '');
        }
      } catch (e) {}
      return original.split(/[?#]/)[0];
    }

    function sendPageView() {
      try {
        var page_type = inferPageType(location.pathname);
        var cluster_name = getClusterName();
        var utm = getUTMParams();

        var eventParams = {
          page_title: document.title || '',
          page_location: location.href,
          page_referrer: document.referrer || '',
          page_type: page_type,
          cluster_name: cluster_name,
          country: window.ga_country || '',
          language: window.ga_language || ''
        };

        if (utm.utm_source) {
          eventParams.utm_source = utm.utm_source;
          eventParams.utm_medium = utm.utm_medium;
          eventParams.utm_campaign = utm.utm_campaign;
          eventParams.utm_content = utm.utm_content;
          eventParams.utm_term = utm.utm_term;
        }

        fire('page_view', eventParams);
      } catch (e) {
        console.error('GA4 page_view error:', e);
      }
    }

    window.inferPageType = inferPageType;
    window.getClusterName = getClusterName;

    if (!previewMode && typeof window.gtag === 'function') {
      window.gtag('js', new Date());
      window.gtag('config', id, {
        send_page_view: false,
        custom_map: {
          'dimension1': 'page_type',
          'dimension2': 'cluster_name',
          'dimension3': 'country',
          'dimension4': 'language',
          'dimension5': 'cta_channel',
          'dimension6': 'cta_position',
          'dimension7': 'cta_label',
          'dimension8': 'link_url'
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', sendPageView);
    } else {
      if (typeof requestIdleCallback !== 'undefined') {
        requestIdleCallback(sendPageView, { timeout: 2000 });
      } else {
        setTimeout(sendPageView, 0);
      }
    }

    /* ============================================================
     * [Patch B] WhatsApp 链接动态注入追踪标识
     * ============================================================ */
    function compactTrackingValue(value, fallback, maxLength) {
      var text = s(value || fallback || '');
      text = text.replace(/\+/g, ' ').replace(/\s+/g, '-').replace(/[^\w.-]+/g, '-').replace(/^-+|-+$/g, '');
      if (!text) return '';
      return text.substring(0, maxLength || 32);
    }

    function currentPageHandle(maxLength) {
      var seg = 'home';
      try {
        seg = location.pathname.split('/').filter(Boolean).slice(-1)[0] || 'home';
      } catch (e) {}
      return compactTrackingValue(seg, 'home', maxLength || 30);
    }

    function buildTrackingTag() {
      var parts = [];
      try {
        var utm = getUTMParams();
        var campaign = compactTrackingValue(utm.utm_campaign, '', 32);
        if (campaign) {
          parts.push('Ad:' + campaign);
        } else if (utm.utm_source) {
          parts.push('Src:' + compactTrackingValue(utm.utm_source, 'google', 16) + '/' + compactTrackingValue(utm.utm_medium, 'cpc', 12));
        }

        parts.push('Page:' + currentPageHandle(30));
      } catch (e) {}
      return parts.length ? ' [' + parts.join(' | ') + ']' : '';
    }

    /**
     * 默认 WhatsApp 开场白：携带当前页面标题，给业务可读的上下文，
     * 同时为买家预填一个简短 B2B 询盘开场（应用 / 数量 / 交期）。
     * 仅在链接本身未提供 ?text= 时使用；不覆盖已自定义的文案。
     */
    function buildDefaultOpener() {
      var title = '';
      try {
        var h1 = document.querySelector('h1');
        title = ((h1 && h1.textContent) ? h1.textContent : document.title) || '';
        title = title.replace(/\s+/g, ' ').trim();
        // 去掉常见的品牌后缀（" – JacquardWorks" / " | ..."），保留核心主题
        title = title.split(/\s[\u2013\u2014|-]\s/)[0].substring(0, 72);
      } catch (e) {}
      var opener = 'Hi JacquardWorks team,';
      if (title) {
        opener += ' I am viewing "' + title + '" and would like fabric details and a quote.';
      } else {
        opener += ' I am interested in your jacquard fabrics and would like details and a quote.';
      }
      opener += ' Application / quantity / timeline: ';
      return opener;
    }

    function rewriteWaLinks() {
      var sel = 'a[href*="wa.me/"], a[href*="api.whatsapp.com"], a[href*="whatsapp.com/send"]';
      var links = document.querySelectorAll(sel);
      var tag = buildTrackingTag();
      var opener = buildDefaultOpener();

      links.forEach(function (a) {
        if (a.dataset.waTagged === '1') return;
        try {
          var u = new URL(a.href);
          // 链接自带 text 则尊重原文案；否则注入页面感知开场白
          var existing = u.searchParams.get('text');
          var baseText = existing && existing.trim() ? existing : opener;
          if (baseText.indexOf('[Ref:') === -1 && baseText.indexOf('[UTM:') === -1 && baseText.indexOf('[Ad:') === -1 && baseText.indexOf('[Src:') === -1 && baseText.indexOf('[Page:') === -1) {
            u.searchParams.set('text', baseText + tag);
            a.href = u.toString();
          } else if (!existing) {
            u.searchParams.set('text', baseText);
            a.href = u.toString();
          }
          a.dataset.waTagged = '1';
        } catch (e) {}
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', rewriteWaLinks);
    } else {
      rewriteWaLinks();
    }
    setTimeout(rewriteWaLinks, 1500);
    setTimeout(rewriteWaLinks, 4000);

    if (typeof MutationObserver !== 'undefined') {
      var rewriteDebounce;
      try {
        new MutationObserver(function () {
          clearTimeout(rewriteDebounce);
          rewriteDebounce = setTimeout(rewriteWaLinks, 500);
        }).observe(document.body, { childList: true, subtree: true });
      } catch (e) {}
    }

    /* ============================================================
     * CTA 追踪（GA4 + Google Ads 双发）
     * ============================================================ */

    function isWhatsAppLink(href) {
      if (!href || typeof href !== 'string') return false;
      var u = href.trim().toLowerCase();
      return u.indexOf('wa.me/') !== -1 ||
        u.indexOf('api.whatsapp.com') !== -1 ||
        u.indexOf('whatsapp.com') !== -1 ||
        u.indexOf('whatsapp://') === 0;
    }

    function isEmailLink(href) {
      if (!href || typeof href !== 'string') return false;
      return href.trim().toLowerCase().indexOf('mailto:') === 0;
    }

    function isWeChatLink(href) {
      if (!href || typeof href !== 'string') return false;
      var u = href.trim().toLowerCase();
      return u.indexOf('weixin://') === 0 ||
        u.indexOf('wx.qq.com') !== -1 ||
        u.indexOf('weixin.qq.com') !== -1;
    }

    function isContactRouteLink(href) {
      if (!href || typeof href !== 'string') return false;
      try {
        var u = new URL(href, location.origin);
        if (u.origin !== location.origin) return false;
        var p = u.pathname.toLowerCase().replace(/\/+$/, '');
        return p === '/pages/contact' || p === '/contact';
      } catch (e) {
        var h = href.trim().toLowerCase();
        return h === '/pages/contact' || h === '/contact';
      }
    }

    function inferPosition(el) {
      if (!el || !el.closest) return 'inline';
      // ⚠️ 与 GA4 现有数据对齐：sidebar → floating_sidebar
      if (el.closest('.floating-contact-sidebar')) return 'floating_sidebar';
      if (el.closest('.mobile-navigation-bar') || el.closest('.mobile-nav-whatsapp')) return 'mobile_menu';
      if (el.closest('.product-single') || el.closest('main .product')) return 'product_page';
      if (el.closest('.product-item') || el.closest('.sec__products-grid')) return 'product_card';
      if (el.closest('.slideshow') || el.closest('.banner-packery') || el.closest('[class*="banner"]')) return 'banner';
      if (el.closest('.footer') || el.closest('footer')) return 'footer';
      if (el.closest('.social-icons') || el.closest('[class*="social"]')) return 'social_icons';
      if (el.closest('.page-faqs') || el.closest('.faq')) return 'faq_page';
      if (el.closest('.product-quickview')) return 'quickview';
      if (el.closest('.minicart') || el.closest('#minicart')) return 'minicart';
      if (el.closest('.rte') || el.closest('.page-content') || el.closest('.rich__text')) return 'inline_content';
      return 'inline';
    }

    function baseParams() {
      var params = {
        page_location: location.href,
        page_referrer: document.referrer || '',
        page_title: document.title || '',
        page_type: inferPageType(location.pathname),
        cluster_name: getClusterName()
      };
      if (window.ga_country) params.country = s(window.ga_country);
      if (window.ga_language) params.language = s(window.ga_language);
      var utm = getUTMParams();
      if (utm.utm_source) {
        params.utm_source = utm.utm_source;
        params.utm_medium = utm.utm_medium;
        params.utm_campaign = utm.utm_campaign;
        params.utm_content = utm.utm_content;
        params.utm_term = utm.utm_term;
      }
      return params;
    }

    function fire(eventName, params) {
      if (previewMode) {
        window.__jwPreviewEvents = window.__jwPreviewEvents || [];
        var previewEvent = { event: eventName, params: params || {}, timestamp: new Date().toISOString() };
        window.__jwPreviewEvents.push(previewEvent);
        if (typeof console !== 'undefined' && console.info) {
          console.info('[JW preview event]', previewEvent);
        }
        return;
      }
      try {
        if (typeof window.gtag === 'function') window.gtag('event', eventName, params || {});
      } catch (e) {
        console.error('GA4 event error:', e);
      }
    }

    function markOnce(key) {
      if (!key) return true;
      try {
        if (window.sessionStorage && window.sessionStorage.getItem(key)) return false;
        if (window.sessionStorage) window.sessionStorage.setItem(key, '1');
        return true;
      } catch (e) {
        return !dedupe(key);
      }
    }

    var leadFunnelDefaults = {
      lead_intent: { value: 10, currency: 'USD', stage: 'intent' },
      generate_lead: { value: 80, currency: 'USD', stage: 'generated' },
      qualify_lead: { value: 300, currency: 'USD', stage: 'qualified' },
      close_convert_lead: { value: 1000, currency: 'USD', stage: 'closed' }
    };

    function getLeadFunnelConfig(eventName, channel) {
      var cfg = window.ADS_CONFIG || {};
      var defaults = leadFunnelDefaults[eventName] || {};
      var funnelCfg = (cfg.lead_funnel && cfg.lead_funnel[eventName]) || {};
      var conv = cfg.conversions && cfg.conversions[channel];
      var useChannelValue = eventName === 'generate_lead';
      return {
        value: useChannelValue && conv && conv.value !== undefined ? conv.value : (funnelCfg.value !== undefined ? funnelCfg.value : defaults.value),
        currency: (useChannelValue && conv && conv.currency) || funnelCfg.currency || defaults.currency || 'USD',
        stage: funnelCfg.stage || defaults.stage || eventName
      };
    }

    function applyCtaConversionParams(params) {
      var p = params || {};
      var cfg = window.ADS_CONFIG || {};
      var conv = cfg.conversions && cfg.conversions[p.cta_channel];
      if (!conv) return p;
      if (p.value === undefined && conv.value !== undefined) p.value = conv.value;
      if (!p.currency && conv.currency) p.currency = conv.currency;
      if (!p.lead_source && p.cta_channel) p.lead_source = p.cta_channel;
      return p;
    }

    function leadIntentParams(params) {
      var p = Object.assign({}, params || {});
      delete p.value;
      delete p.currency;
      return p;
    }

    function applyLeadFunnelParams(eventName, params) {
      var p = params || {};
      var meta = getLeadFunnelConfig(eventName, p.cta_channel || p.lead_source);
      p.event_category = p.event_category || 'b2b_lead_funnel';
      p.lead_stage = p.lead_stage || meta.stage;
      p.lead_source = p.lead_source || p.cta_channel || 'website';
      p.source_platform = p.source_platform || 'shopify_theme';
      if (p.value === undefined && meta.value !== undefined) p.value = meta.value;
      if (!p.currency) p.currency = meta.currency;
      return p;
    }

    function sendLeadFunnelEvent(eventName, params) {
      if (!leadFunnelDefaults[eventName]) return false;
      var p = Object.assign(baseParams(), params || {});
      applyLeadFunnelParams(eventName, p);
      fire(eventName, p);
      return p;
    }

    /* ============================================================
     * [Patch C] Google Ads 转化触发
     * ============================================================ */
    function fireAdsConversion(channel, customParams) {
      if (previewMode) return;
      try {
        var cfg = window.ADS_CONFIG || {};
        var conv = cfg.conversions && cfg.conversions[channel];
        if (!conv || !conv.label || !cfg.conversion_id) return;
        // 占位符防呆 - 未配置时静默不发
        if (cfg.conversion_id.indexOf('XXX') !== -1) {
          console.warn('[Ads] conversion_id 未配置，跳过 ' + channel + ' 转化');
          return;
        }
        if (conv.label.indexOf('AAA') === 0 || conv.label.indexOf('BBB') === 0 ||
            conv.label.indexOf('CCC') === 0 || conv.label.indexOf('DDD') === 0) {
          console.warn('[Ads] ' + channel + ' label 未配置，跳过');
          return;
        }

        var payload = {
          'send_to': cfg.conversion_id + '/' + conv.label,
          'value': conv.value || 0,
          'currency': conv.currency || 'USD',
          'transaction_id': Date.now() + '_' + Math.random().toString(36).substr(2, 9)
        };

        // Enhanced Conversions for Leads（如果用户登录过/留过资料）
        if (customParams && customParams.user_data) {
          payload.user_data = customParams.user_data;
        }

        window.gtag('event', 'conversion', payload);
      } catch (e) {
        console.error('Ads conversion error:', e);
      }
    }

    var lastSig = '', lastTs = 0;
    function dedupe(sig) {
      var now = Date.now();
      if (sig && sig === lastSig && (now - lastTs) < 1000) return true;
      lastSig = sig;
      lastTs = now;
      return false;
    }

    var channelEventNames = {
      whatsapp: 'whatsapp_click',
      email: 'email_click',
      wechat: 'wechat_click'
    };

    function fireChannelEvent(channel, params) {
      var eventName = channelEventNames[channel];
      if (!eventName) return;
      fire(eventName, params);
    }

    function sendSecondaryEvent(eventName, channel, position, label, linkUrl) {
      var p = baseParams();
      p.cta_channel = channel || 'other';
      p.cta_position = position || 'unknown';
      p.cta_label = label || eventName;
      p.link_url = linkUrl || '';
      fire(eventName, p);
      return p;
    }

    function sendLeadIntent(intentType, params) {
      var p = Object.assign({}, params || {});
      p.intent_type = intentType || 'lead_intent';
      p.cta_channel = p.cta_channel || 'behavior';
      p.cta_position = p.cta_position || inferPageType(location.pathname) || 'page';
      p.cta_label = p.cta_label || p.intent_type;
      var key = [
        'jw_ga4_lead_intent',
        p.intent_type,
        location.pathname.toLowerCase(),
        p.cta_channel,
        p.cta_position
      ].join('|');
      if (markOnce(key)) return sendLeadFunnelEvent('lead_intent', p);
      return false;
    }

    function sendCta(channel, position, label, linkUrl) {
      var p = baseParams();
      p.cta_channel = (channel && channel !== '') ? channel : 'other';
      p.cta_position = (position && position !== '') ? position : 'unknown';
      p.cta_label = (label && label !== '') ? label : 'cta_click';
      p.link_url = isWhatsAppLink(linkUrl) ? normalizeWhatsAppLinkUrl(linkUrl) : (linkUrl || '');
      applyCtaConversionParams(p);

      // 1. GA4 事件
      fire('cta_click', p);
      fireChannelEvent(p.cta_channel, p);
      if (p.cta_channel === 'whatsapp' || p.cta_channel === 'email' || p.cta_channel === 'wechat') {
        sendLeadIntent('direct_contact_click', leadIntentParams(p));
        var leadParams = Object.assign({}, p);
        leadParams.lead_source = p.cta_channel;
        sendLeadFunnelEvent('generate_lead', leadParams);
      }

      // 2. Google Ads 转化（同步）
      fireAdsConversion(p.cta_channel);
    }

    // 暴露给手动调用（例如表单提交后）
    window.sendCtaEvent = sendCta;
    window.sendLeadIntentEvent = sendLeadIntent;
    window.sendB2BLeadEvent = sendLeadFunnelEvent;
    window.sendQualifyLeadEvent = function (params) {
      return sendLeadFunnelEvent('qualify_lead', params || {});
    };
    window.sendCloseConvertLeadEvent = function (params) {
      return sendLeadFunnelEvent('close_convert_lead', params || {});
    };
    window.fireAdsConversion = fireAdsConversion;

    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t) return;

      var link = t.closest ? t.closest('a') : null;
      var ctaEl = t.closest ? t.closest('.js-cta') : null;

      if (link) {
        var href = s(link.getAttribute('href') || link.href);
        if (href) {
          var posA = s(link.getAttribute('data-cta-position')) || inferPosition(link);
          var labelA = s(link.getAttribute('data-cta-label')) || s(link.textContent) || posA || 'cta_click';

          if (isWhatsAppLink(href)) {
            var analyticsHref = normalizeWhatsAppLinkUrl(href);
            var sigA = 'wa|' + analyticsHref + '|' + posA;
            if (!dedupe(sigA)) sendCta('whatsapp', posA, labelA, href);
            return;
          }
          if (isEmailLink(href)) {
            var sigB = 'em|' + href + '|' + posA;
            if (!dedupe(sigB)) sendCta('email', posA, labelA, href);
            return;
          }
          if (isWeChatLink(href)) {
            var sigW = 'wc|' + href + '|' + posA;
            if (!dedupe(sigW)) sendCta('wechat', posA, labelA, href);
            return;
          }
          if (isContactRouteLink(href)) {
            var sigContact = 'contact|' + href + '|' + posA;
            if (!dedupe(sigContact)) {
              var contactParams = sendSecondaryEvent('contact_route_click', 'contact_page', posA, labelA, href);
              sendLeadIntent('contact_route_click', contactParams);
            }
            return;
          }
        }
      }

      var wechatQrBtn = t.closest ? t.closest('[data-fcs-wechat-btn], [data-mobile-wechat-btn]') : null;
      if (wechatQrBtn) {
        var posWechatQr = s(wechatQrBtn.getAttribute('data-cta-position')) || inferPosition(wechatQrBtn);
        var labelWechatQr = s(wechatQrBtn.getAttribute('data-cta-label')) || s(wechatQrBtn.textContent) || 'wechat_qr';
        var sigWechatQr = 'wechat_qr|' + posWechatQr + '|' + labelWechatQr;
        if (!dedupe(sigWechatQr)) {
          var wechatParams = sendSecondaryEvent('wechat_qr_open', 'wechat', posWechatQr, labelWechatQr, '');
          sendLeadIntent('wechat_qr_open', wechatParams);
        }
        return;
      }

      if (ctaEl) {
        var channel = s(ctaEl.getAttribute('data-cta-channel'));
        var pos = s(ctaEl.getAttribute('data-cta-position')) || inferPosition(ctaEl);
        var label = s(ctaEl.getAttribute('data-cta-label')) || s(ctaEl.textContent) || pos || 'cta_click';
        var linkUrl = '';
        if (ctaEl.tagName === 'A') linkUrl = s(ctaEl.getAttribute('href') || ctaEl.href);
        var sigC = 'cta|' + channel + '|' + pos + '|' + label;
        if (!dedupe(sigC)) sendCta(channel, pos, label, linkUrl);
      }
    }, true);

    /* ============================================================
     * [Patch D] 表单提交监听（含 Enhanced Conversions 支持）
     * ============================================================ */
    async function sha256Hex(str) {
      try {
        if (!str || !window.crypto || !window.crypto.subtle) return '';
        var buf = new TextEncoder().encode(str.trim().toLowerCase());
        var hash = await window.crypto.subtle.digest('SHA-256', buf);
        return Array.from(new Uint8Array(hash))
          .map(function (b) { return b.toString(16).padStart(2, '0'); }).join('');
      } catch (e) { return ''; }
    }

    function isSpamGuardBlocked(form) {
      if (!form || !form.querySelector) return false;
      var honeypot = form.querySelector('input[name="contact[website]"]');
      var filledHoneypot = honeypot && honeypot.value && honeypot.value.trim() !== '';
      var tooFast = Number(form.dataset.spamGuardReadyAt || 0) > Date.now();
      var duplicate = form.dataset.spamGuardSubmitting === 'true';
      return Boolean(filledHoneypot || tooFast || duplicate);
    }

    document.addEventListener('submit', async function (e) {
      var form = e.target;
      if (!form || !form.tagName || form.tagName !== 'FORM') return;

      // 仅追踪联系/询盘表单（避免搜索、登录、newsletter 等误触）
      var action = (form.action || '').toLowerCase();
      var formId = (form.id || '').toLowerCase();
      var formClass = (form.className || '').toLowerCase();
      var isInquiry = action.indexOf('/contact') >= 0 ||
        formId.indexOf('contact') >= 0 || formId.indexOf('inquiry') >= 0 ||
        formClass.indexOf('contact') >= 0 || formClass.indexOf('inquiry') >= 0 ||
        form.hasAttribute('data-inquiry-form');
      if (!isInquiry) return;
      if (isSpamGuardBlocked(form)) return;

      var p = baseParams();
      p.cta_channel = 'form';
      p.cta_position = 'inquiry_form';
      p.cta_label = formId || 'contact_form';
      p.lead_source = 'contact_form';
      applyCtaConversionParams(p);
      fire('cta_click', p);
      fire('contact_form_submit', p);
      sendLeadIntent('form_submit', leadIntentParams(p));
      var formLeadParams = Object.assign({}, p);
      sendLeadFunnelEvent('generate_lead', formLeadParams);

      // Enhanced Conversions：哈希后的 email/phone
      try {
        var emailEl = form.querySelector('input[type=email], input[name*=email i]');
        var phoneEl = form.querySelector('input[type=tel], input[name*=phone i]');
        var emailVal = emailEl ? emailEl.value : '';
        var phoneVal = phoneEl ? phoneEl.value : '';

        var user_data = {};
        if (emailVal) {
          var eh = await sha256Hex(emailVal);
          if (eh) user_data.sha256_email_address = eh;
        }
        if (phoneVal) {
          var ph = await sha256Hex(phoneVal.replace(/[^\d+]/g, ''));
          if (ph) user_data.sha256_phone_number = ph;
        }
        fireAdsConversion('form', Object.keys(user_data).length ? { user_data: user_data } : null);
      } catch (err) {
        fireAdsConversion('form');
      }
    }, true);

    function isLeadIntentPage() {
      var pageType = inferPageType(location.pathname);
      return pageType === 'product' ||
        pageType === 'collections' ||
        pageType === 'landing_page' ||
        pageType === 'contact';
    }

    function scheduleEngagedLeadIntent() {
      if (!isLeadIntentPage()) return;
      var visibleMs = 0;
      var lastTs = Date.now();
      var fired = false;

      function updateVisibleTime() {
        var now = Date.now();
        if (document.visibilityState !== 'hidden') visibleMs += now - lastTs;
        lastTs = now;
      }

      function check() {
        if (fired) return;
        updateVisibleTime();
        if (visibleMs >= 60000) {
          fired = true;
          sendLeadIntent('engaged_60s', {
            cta_channel: 'engagement',
            cta_position: inferPageType(location.pathname),
            cta_label: 'engaged_60s',
            engagement_seconds: 60
          });
          return;
        }
        setTimeout(check, 5000);
      }

      document.addEventListener('visibilitychange', updateVisibleTime);
      setTimeout(check, 5000);
    }

    scheduleEngagedLeadIntent();

  });
})();

/*
 * ============================================================
 * 部署说明（重要）
 * ============================================================
 *
 * 一、<head> 内代码（替换原来的 gtag 加载块）
 *
 * <!-- Google tag (gtag.js) - GA4 + Google Ads -->
 * <script async src="https://www.googletagmanager.com/gtag/js?id=G-5EVDVD1GWK"></script>
 * <script>
 *   window.dataLayer = window.dataLayer || [];
 *   function gtag(){ dataLayer.push(arguments); }
 *   gtag('js', new Date());
 *
 *   // GA4
 *   window.ga_measurement_id = 'G-5EVDVD1GWK';
 *   window.ga_country  = '{{ request.locale.iso_code }}';
 *   window.ga_language = '{{ request.locale.iso_code }}';
 *   gtag('config', 'G-5EVDVD1GWK', { send_page_view: false });
 *
 *   // Google Ads（部署后把 AW-XXXXXXXXX 替换为真实 Conversion ID）
 *   gtag('config', 'AW-XXXXXXXXX', { 'allow_enhanced_conversions': true });
 * </script>
 *
 * 二、Google Ads 后台需要做的事
 *
 * 1. 工具 → 转化 → 新建转化操作（建 4 个）
 *    ┌────────────────────────────┬──────────────────────┬──────┬──────┐
 *    │ 名称                       │ 类别                 │ 价值 │ 计数 │
 *    ├────────────────────────────┼──────────────────────┼──────┼──────┤
 *    │ WhatsApp_Click             │ 潜在客户-提交联系信息 │ $50  │ 每次 │
 *    │ Email_Click                │ 潜在客户-提交联系信息 │ $30  │ 每次 │
 *    │ WeChat_Click               │ 潜在客户-提交联系信息 │ $20  │ 每次 │
 *    │ Inquiry_Form_Submit        │ 潜在客户-提交联系信息 │ $80  │ 每次 │
 *    │ WhatsApp_Qualified_Lead    │ 潜在客户-已成交       │ 动态 │ 每次 │ ← 线下导入
 *    └────────────────────────────┴──────────────────────┴──────┴──────┘
 *    - 转化时间窗：30 天
 *    - 归因模型：数据驱动（账户数据少时用「最终点击」）
 *    - 增强型转化（Enhanced Conversions）：开启
 *
 * 2. 每个转化建好后，会拿到一对：
 *      Conversion ID:    AW-XXXXXXXXX  (账号级，所有转化共享)
 *      Conversion Label: aaaaaaaaaaaa  (每个转化独立)
 *    把它们填到本文件顶部 ADS_CONFIG.conversions 里
 *
 * 3. GA4 ↔ Google Ads 链接
 *    在 GA4 → 管理 → 产品链接 → Google Ads 链接 中关联账号 640-338-6843
 *    这样可以把 GA4 的 cta_click 关键事件直接当作 Ads 转化导入
 *    （比 gtag 双发更稳定，可作为备份方案）
 *
 * 4. 自动标记（Auto-tagging）确认开启
 *    Google Ads → 管理员 → 偏好设置 → Auto-tagging → ON
 *    这样所有广告点击 URL 会自动带 gclid 参数
 *
 * 三、Shopify 主题需要做的事
 *
 * 1. 替换 ga4-tracking.js（注意 position 已从 sidebar 改为 floating_sidebar）
 *    如果不希望改 GA4 历史维度，把第 247 行改回 'sidebar' 即可
 *
 * 2. 联系/询盘表单加 data-inquiry-form 属性（或包含 contact/inquiry 关键字）
 *    <form action="/contact" id="ContactForm" data-inquiry-form>
 *
 * 四、验证清单（部署后 24 小时内）
 *
 * 1. 打开 Chrome DevTools → Network → 输入 collect 过滤
 *    点击任一 WhatsApp 按钮，应看到：
 *      - 一条 GA4 collect 请求（en=cta_click）
 *      - 一条 Ads collect 请求（en=conversion）
 *
 * 2. Google Ads → 工具 → 转化 → 看 WhatsApp_Click 状态
 *    应在 1 小时内从「未验证」变为「正在记录转化」
 *
 * 3. 测试 GCLID 注入：
 *    访问 https://jacquardwork.com/?gclid=TEST_GCLID_123
 *    打开任一 WhatsApp 按钮，链接的 text 参数应包含 [Ref:TEST_GCLID_123 ...]
 *
 * 4. GA4 → 实时 → 事件，应看到 cta_click 实时上报
 * ============================================================
 */
